import { useState, useEffect } from 'react';

const useDeviceWidth = () => {
	// Initialize state with a default value that works on server
	const [width, setWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : 0
	);

	useEffect(() => {
		// Ensure window is available (client-side only)
		if (typeof window === 'undefined') return;

		const handleResize = () => setWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return width;
};

export default useDeviceWidth;
